import BaseServiceV2 from "../BaseServiceV2";
import ApiUrl from '../ApiUrl';
import TestDurumEnum from "../../enum/TestMerkezi/TestDurumEnum";

class AdayTestService extends BaseServiceV2 {

    constructor() {
        super(ApiUrl.IKTestMerkeziDomain + ApiUrl.controller.AdayTest);
    }

    createWithGuid = async (data) => {
        return await this.easyPost('/createwithguid', data);
    }

    getQuestions = async (guid, token) => {
        return await this.easyGet('/getquestion', { TestGUID: guid }, token);
    }

    completeTest = async (testId, token) => {
        try {
            const updateData = {
                Id: testId,
                Durum: TestDurumEnum.Yanitlandi,
                BitisZamani: new Date().toISOString()
            };
            
            return await this.easyPost(this.ApiUrl.endpoint.UpdateDynamic, updateData, token);
        } catch (error) {
            console.error('Test tamamlanırken hata:', error);
            throw error;
        }
    }

    hesaplaTestSonuclari = async (testId, token) => {
        const endpointWithQuery = `/HesaplaTestSonuclari?id=${testId}`;
        return await this.easyPost(endpointWithQuery, {}, token);
    }

    updateTest = async (data, token) => {
        return await this.easyPost(this.ApiUrl.endpoint.UpdateDynamic, data, token);
    }
}

const adayTestService = new AdayTestService();

export default adayTestService;
